import React from "react";
import NoContent from "./NoContent";
import HomePage from "@system/config/home-page";
import CommonHomePageContent from "src/pages/HomePageContent/Common";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import HelperAnalyticsEvent from "src/support/HelperAnalyticsEvent";
import AxiosIndicatorRunTimeLoader from "../AxiosIndicatorRunTimeLoader";

const NewProductInformation = (props) => {
  const { npiList, searchText, apiCall } = props;
  const [__check] = useAxiosIndicatorCheck();

  const typeHeadSearchEvent = (obj) => {
    HelperAnalyticsEvent.typeHeadSearchEvent(searchText, "New Product Information", obj?.name, new URL(obj?.url).pathname)
  }

  return (
    <>
      <div className="search-item-title text-uppercase">
        RECOMMENDED New Product Information
      </div>
      {__check(['UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL']).status && !apiCall.Npi ?
        <AxiosIndicatorRunTimeLoader />
        : <>
          {Object.keys(npiList).length > 0 ? (
            <>
              <div className="search-product-list">
                {Object.keys(npiList).length > 0 &&
                  Object.entries(npiList).map((v, i) => (
                    <React.Fragment key={i}>
                      {i < 5 && (
                        <div className="search-product-list-item">
                          <div className="search-product-list-item-info">
                            <a onClick={() => typeHeadSearchEvent(v[1])}
                              href={(v[1].url)}
                              className="cursor-pointer"
                              key={i}
                            >
                              <div className="search-product-list-info-title">
                                {v[1].name}
                              </div>

                            </a>
                            <div className="search-product-list-info-desc">
                              {v[1].shortDescription}
                            </div>
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  ))}
              </div>
              <a
                href={
                  HomePage.makeHomeTabsListRouteURL(
                    CommonHomePageContent.chain_HomeTabList.NPIT.param_value
                  ) +
                  "&search=" +
                  searchText +
                  "&viewAll=true"
                }
                className="text-center mt-auto pb-3 pt-3"
              >
                <div className="bs5 btn btn-sm btn-primary">
                  VIEW ALL New Product Information Results
                </div>
              </a>
            </>

          )
            : <NoContent />}
        </>}
    </>
  );
};

export default NewProductInformation;
